const MerchantServicesAddServiceBasicInfo = props => {
  return (
    <>
      <h1>Add Service - Basic Info</h1>
    </>
  )
}

export default MerchantServicesAddServiceBasicInfo;